<script setup lang="ts">
import { RouterView } from 'vue-router';

import ConfirmDialog from '@/components/ui/ConfirmDialog.vue';
import ToastHost from '@/components/ui/ToastHost.vue';
</script>

<template>
  <RouterView />
  <ToastHost />
  <ConfirmDialog />
</template>
